export const DATE_TYPES = {
  SPECIFIC: 'specific',
  MONTH: 'month',
  ANY_TIME: 'anytime',
} as const;
export const { ANY_TIME, MONTH, SPECIFIC } = DATE_TYPES;
export type DateType = keyof typeof DATE_TYPES;
